import React from 'react';
import { find } from 'lodash';
import { connect } from 'react-redux';
import ViewLoading from 'components/view/loading';
import RenderPage from 'components/apps/render';
import NotFoundPage from 'components/pages/error/404';
import actions from 'actions';

const mapStateToProps = (state) => ({
  app: state.apps.record,
  installedApps: state.client.apps,
});

const mapDispatchToProps = (dispatch) => ({
  fetchApp: (id) => {
    return dispatch(actions.apps.fetch(id));
  },
});

export class RenderApp extends React.PureComponent {
  state = {
    loaded: false,
    app: null,
    installedApp: null,
  };

  mounted = false;

  componentWillMount() {
    this.mounted = true;
    this.fetchApp();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    const { params } = this.props;

    if (params.id !== nextProps.params.id) {
      this.setState({ loaded: false });
      this.fetchApp(nextProps);
    }
  }

  async fetchApp(props = this.props) {
    const { params, installedApps, fetchApp } = props;

    try {
      const installedApp = find(installedApps?.results, {
        app_private_id: `_${params.id}`,
      });
      if (!installedApp) {
        this.setState({
          loaded: true,
        });
        return;
      }

      const app = await fetchApp(installedApp.app_id);

      if (this.mounted) {
        this.setState({
          loaded: true,
          app,
          installedApp,
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    if (!this.state.loaded) {
      return <ViewLoading />;
    }

    if (!this.state.app || !this.state.installedApp) {
      return <NotFoundPage />;
    }

    return <RenderPage {...this.props} {...this.state} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RenderApp);
